<script>
import { vSlidenIn } from '@/utils/vSlidenIn.js';
import { vZoomIn } from '@/utils/vZoomIn.js';

export default {
  name: 'SolutionConsult',
  directives: {
    slidenIn: vSlidenIn,
    zoomIn: vZoomIn,
  },
  data() {
    return {
      sections: [
        {
          title: '1. Oil & Gas Development Engineering Digital Services',
          subtitle:
            'Covering the full lifecycle of oil and gas exploration, development, and construction, this solution enables intelligent management of reservoirs, engineering operations, and wellsite production through data integration and analytics—improving efficiency and resource utilization.',
          consultLabel: 'Oil & Gas Development Engineering Digital Services',
          cards: [
            { href: '/intelligentReservoir', title: 'Smart Geo-Engineering', image: require('@/assets/anxun1.png'), duration: 600 },
            { href: '/monitorAnxun', title: 'Smart Drilling', image: require('@/assets/home6.png'), duration: 1000 },
            { href: '/wellbore', title: 'Smart Wellbore', image: require('@/assets/home/wellbore.jpeg'), duration: 1000 },
          ],
        },
        {
          title: '2. Oil & Gas Facility Digital Services',
          subtitle:
            'Covering production and transportation processes, this solution enables automated control, real-time monitoring, and production optimization—enhancing station operations, pipeline safety, and refining efficiency.',
          consultLabel: 'Oil & Gas Facility Digital Services',
          cards: [
            { href: '/station', title: 'Smart O&G Processing Stations', image: require('@/assets/home1.png'), duration: 600 },
            { href: '/product', title: 'Smart Production & Metering Stations', image: require('@/assets/home3.png'), duration: 600 },
            { href: '/pipeline', title: 'Smart Pipeline & Storage', image: require('@/assets/home7.png'), duration: 600 },
            { href: '/refining', title: 'Smart Refining & Processing', image: require('@/assets/anxun2.png'), duration: 600 },
            { href: '/control', title: 'Smart Integrated Control System', image: require('@/assets/home/control.jpeg'), duration: 600 },
          ],
        },
        {
          title: '3. Smart Security Services',
          subtitle:
            'Focused on safety and operational assurance, this solution integrates AI video surveillance, personnel tracking, and early warning systems to build a comprehensive security framework.',
          consultLabel: 'Smart Security Services',
          cards: [{ href: '/security', title: 'Smart Security', image: require('@/assets/home2.png'), duration: 800 }],
        },
        {
          title: '4. New Energy Digital Services',
          subtitle:
            'Addressing energy transition needs, this solution enables efficient operation and intelligent O&M of new energy assets—supporting cost reduction and low-carbon development.',
          consultLabel: 'New Energy Digital Services',
          cards: [{ href: '/newEnergy', title: 'New Energy Digital Services', image: require('@/assets/anxun4.png'), duration: 800 }],
        },
        {
          title: '5. Specialized AI Empowerment',
          subtitle:
            'Leveraging oil & gas expertise and industry data, we deliver AI products, custom development and data governance for oilfields.',
          consultLabel: 'Specialized AI Empowerment',
          cards: [
            { href: '/oilfieldAI', title: 'Oil & Gas Development AI Products & Customized Services', image: require('@/assets/pro1.jpg'), duration: 800 },
            { href: '/enterpriseAI', title: 'Enterprise Management AI Products & Customized Services', image: require('@/assets/knowledgenew1.jpg'), duration: 800 },
            { href: '/company', title: 'Data Governance Services', image: require('@/assets/zijian3.png'), duration: 800 },
          ],
        },
      ],
    };
  },
  methods: {
    clickConsult(itemName) {
      this.$emit('clickConsult', itemName);
    },
    getSectionEl(index) {
      const ref = this.$refs.sectionRef;
      if (!ref) return null;
      return Array.isArray(ref) ? ref[index] : ref;
    },
  },
};
</script>

<template>
  <div class="solution-consult">
    <div
      v-for="(section, index) in sections"
      :key="index"
      ref="sectionRef"
      :class="['solution-section', { 'solution-section--alt': index % 2 === 1 }]"
    >
      <div class="section-header">
        <div style="display: flex; margin: 0 auto;">
          <div style="display: flex; margin: 0 auto; text-align: center;">
            <div class="title" v-sliden-in="{ duration: 600 }">{{ section.title }}</div>
          </div>
        </div>
        <div v-if="section.cards.length > 1" class="light" style="width: fit-content;" v-sliden-in="{ duration: 600 }">
          {{ section.subtitle }}
          <span class="light2">
            <br />
            For a deeper product demo and technical discussion, please
            <span
              class="clickinfo"
              style="color: white; background-color: #282d7d; padding: 5px; border-radius: 9px; font-weight: bolder; font-size: 1.1vw; cursor: pointer"
              @click="clickConsult(section.consultLabel)"
            >
              Contact Us
            </span>
            .
          </span>
        </div>
      </div>

      <div
        v-if="section.cards.length > 1"
        class="pro3"
        style="grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr); display: grid; overflow-y: hidden; grid-column-gap: 1vw; grid-row-gap: 0.5vw;"
      >
        <a v-for="(card, cardIndex) in section.cards" :key="cardIndex" :href="card.href" target="_blank">
          <div class="grand1" style="position: relative; height: fit-content;" v-zoom-in="{ duration: card.duration }">
            <div class="back">
              <div class="photo">
                <img class="image" style="border-radius: 9px" :src="card.image" />
              </div>
            </div>
            <div class="back1">
              <div class="title1" v-html="card.titleHtml || card.title"></div>
              <div class="title2">
                MORE&nbsp;<img style="width: 0.6vw; object-fit: contain; border-radius: 9px" src="@/assets/more_btn_icon.png" />
              </div>
            </div>
          </div>
        </a>
      </div>

      <div v-else class="section-single-card-lr">
        <div class="section-single-left">
          <div class="light light-left" v-sliden-in="{ duration: 600 }">
            {{ section.subtitle }}
            <span class="light2">
              <br />
              For service support in related business scenarios, please
              <span
                class="clickinfo"
                style="color: white; background-color: #282d7d; padding: 5px; border-radius: 9px; font-weight: bolder; font-size: 1.1vw; cursor: pointer"
                @click="clickConsult(section.consultLabel)"
              >
                Contact Us
              </span>
              .
            </span>
          </div>
        </div>
        <div class="section-single-right">
          <a :href="section.cards[0].href" target="_blank">
            <div class="grand1 grand1-single" style="position: relative; height: fit-content;" v-zoom-in="{ duration: section.cards[0].duration }">
              <div class="back">
                <div class="photo">
                  <img class="image" style="border-radius: 9px" :src="section.cards[0].image" />
                </div>
              </div>
              <div class="back1">
                <div class="title1" v-html="section.cards[0].titleHtml || section.cards[0].title"></div>
                <div class="title2">
                  MORE&nbsp;<img style="width: 0.6vw; object-fit: contain; border-radius: 9px" src="@/assets/more_btn_icon.png" />
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.solution-consult {
  z-index: 10;
  width: 100%;
  height: fit-content;
  padding: 0;
  background: #ffffff;
}

.solution-section {
  margin-bottom: 4vh;
  padding: 5vh 8.09763142692085vw 8vh 8.09763142692085vw;
  border-radius: 0;
  background-color: #eeeeee;
}

.solution-section:last-child {
  margin-bottom: 0;
}

.solution-section--alt {
  background-color: #ffffff;
}

.section-header {
  margin-bottom: 4vw;
}

.title {
  height: 8.23733003708282vh;
  opacity: 1;
  font-size: 2.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 700;
  line-height: 4.23733003708282vh;
}

.light {
  margin: 0 auto 1.5vh auto;
  text-align: justify;
  width: 66vw;
  height: fit-content;
  font-size: 1.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 400;
  color: #2c3e50;
  line-height: 4.94437577255871vh;
}

.light2 {
  margin: 0 auto;
  text-align: justify;
  width: 60.9693818602vw;
  font-size: 1.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 400;
  color: #ff6400;
}

.solution-consult .grand1 {
  cursor: pointer;
  width: 100%;
  border-radius: 6px;
  padding: 0.98887515451174vh 0 0 0;
  opacity: 1;
  height: 250px;
  position: relative;
}

.solution-consult .grand1 .back {
  width: 100%;
  height: fit-content;
  background-color: white;
  border: white 2px solid;
}

.solution-consult .grand1 .back1 {
  bottom: 0;
  position: absolute;
  width: 100%;
  color: white;
  min-height: 30%;
  background: linear-gradient(to top, rgba(27, 30, 118, 1) 0%, rgba(27, 30, 118, 1) 50%, transparent 100%);
  border: white 2px solid;
  border-top: none;
  display: flex;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  padding: 10px 15px;
  justify-content: space-between;
}

.solution-consult .grand1 .photo {
  overflow: hidden;
  border-radius: 9px;
  border: #dddddd 3px solid;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1.25;
  width: 100%;
  height: 35vh;
}

.solution-consult .grand1 .title1 {
  opacity: 4;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4vw;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  color: white;
}

.solution-consult .grand1 .title2 {
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 4;
  height: 100%;
  margin: auto 0 0 auto;
  font-size: 1.2vw;
  font-family: Roboto, sans-serif;
  font-weight: 500;
}

.pro3 {
  height: fit-content;
  width: 100%;
  overflow-x: hidden;
}

.section-single-card-lr {
  display: flex;
  align-items: center;
  gap: 3vw;
  width: 100%;
}

.section-single-left {
  flex: 0 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.section-single-left .light-left {
  margin: 0;
  width: 100%;
  max-width: none;
}

.section-single-right {
  flex: 0 1 50%;
  min-width: 0;
}

.section-single-right a {
  display: block;
}

.section-single-right .grand1-single {
  max-width: 100%;
}

.section-single-right .grand1-single .photo {
  height: 44vh;
}
</style>
